<mat-card
  class="fz-play-event-card"
  appearance="outlined"
  [class.fz-play-event-card--enabled]="enabled && !ended"
  [class.fz-play-event-card--ended]="ended"
>
  <div class="header">
    <div class="event-code">
      @if (eventCode) {
        <fz-event-number [eventCode]="eventCode"></fz-event-number>
      }
    </div>

    <mat-button-toggle-group
      class="view-mode"
      name="card-view-mode"
      aria-label="Change card view mode"
      hideSingleSelectionIndicator="true"
      [value]="viewMode()"
      [disabled]="!enabled"
      (valueChange)="onViewModeChange($event)"
    >
      <mat-button-toggle value="overview">Overview</mat-button-toggle>
      <mat-button-toggle value="leaderboard">Leaderboard</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  @if (viewMode() == 'overview') {
    <div class="overview">
      <div class="section-1">
        <div class="available-seats">
          <div class="available-seats__title bloc-title">Available seats</div>
          <div class="available-seats__counter">
            <span
              class="animated-number-change"
              [style.--num]="seatsAvailable"
            ></span>
            of {{ seats }}
          </div>
        </div>

        <div class="first-place">
          <span class="bloc-title">1st Place</span>
          <div class="profile-name">
            @if (participants.length > 0) {
              <div class="profile-name__content">
                {{ participants[0].player }}
              </div>
            } @else {
              Be the first
            }
          </div>
          <div class="l-badge">
            <span
              class="animated-number-change"
              [style.--num]="participants.length"
            ></span>
            {{ participants.length > 1 ? 'more' : '' }} in leaderboard
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div class="section-2">
        <div class="started-by">
          <span class="bloc-title">Started by</span>

          <div class="profile-name">
            <span class="profile-name__content">
              @if (event.firstPlayedBy) {
                {{ event.firstPlayedBy }}
              } @else {
                No one yet.
              }
            </span>
          </div>

          @if (event.firstPlayedAt) {
            <div class="date">
              <span class="date__small">
                {{ event.firstPlayedAt | fzDateFormat: 'small' | async }}
              </span>
              <span class="date__medium">
                {{ event.firstPlayedAt | fzDateFormat: 'medium' | async }}
              </span>
            </div>
          } @else {
            <span class="mat-body-small font-color--secundary"
              >Start this game by playing in it.</span
            >
          }
        </div>

        @if (event.lastPlayedBy) {
          <div class="last-played-by">
            <span class="bloc-title">Last played by</span>
            <div class="profile-name">
              <span class="profile-name__content">
                {{ event.lastPlayedBy }}
              </span>
            </div>
            <span class="date">
              <span class="date__small">
                {{ event.lastPlayedAt | fzDateFormat: 'small' | async }}</span
              >
              <span class="date__medium">
                {{ event.lastPlayedAt | fzDateFormat: 'medium' | async }}</span
              >
            </span>
          </div>
        }
      </div>
    </div>
  }

  @if (viewMode() == 'leaderboard') {
    <fz-leaderboard
      [seats]="seats"
      [participants]="participants"
    ></fz-leaderboard>
  }

  <mat-card-actions>
    <button
      mat-flat-button
      color="primary"
      class="full-width"
      [disabled]="!enabled || isPlayStarting || ended"
      [fzProcessing]="isPlayStarting"
      (click)="handlePlayPress()"
    >
      <div class="button-content">
        @if (ended) {
          Ended - {{ event.entryFee | fzCurrency }}
        } @else {
          @if (next) {
            Play Next
          } @else {
            Play - {{ event.entryFee | fzCurrency }}
          }
        }
      </div>
    </button>
  </mat-card-actions>
</mat-card>
